<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
        <tr>
          <td class="label-col">无需清洗</td>
          <td>
            <el-tag type="danger"
                    v-if="fullNode.project_node.node_result.not_clear_files">
              无需清洗
            </el-tag>
            <el-tag type="success"
                    v-else>
              需要清洗
            </el-tag>
            <span style="font-size: 12px;color: #909399;margin-left: 10px;">开启后将跳过地址清洗流程，直接进入下一阶段</span>
          </td>
        </tr>
        <tr>
          <td class="label-col">清洗规则</td>
          <td>{{fullNode.project_node.node_result.clear_file_by}}</td>
        </tr>
        <tr>
          <td class="label-col">返回时间</td>
          <td>{{fullNode.project_node.node_result.except_upload_cleaned_file_at}}</td>
        </tr>
        <tr>
          <td class="label-col">当前版本号</td>
          <td>{{fullNode.project_node.node_result.version}}</td>
        </tr>
        <tr>
          <td class="label-col">备注</td>
          <td>{{ fullNode.project_node.node_result.file_remarks }}</td>
        </tr>
        <tr>
          <td class="label-col">附件</td>
          <td>
            <AttachmentViewer :files="fullNode.project_node.node_result.customer_files"></AttachmentViewer>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AttachmentViewer from '@views/project/node-views/AttachmentViewer.vue'
import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom, AttachmentViewer},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {}
  },
  created () {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/UploadCustomerListView.vue